import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as RA from 'ramda-adjunct';
import * as fromAuth from './auth.reducer';
import {AuthenticationStatus} from '@emm/core/models/enums';

export const getAuthState = createFeatureSelector<fromAuth.State, fromAuth.AuthState>(
    fromAuth.authFeatureKey
);

const getUser = createSelector(getAuthState, (state) => state.user);
const getStatus = createSelector(getAuthState, (state) => state.status);
const getAuthenticated = createSelector(
    getStatus,
    (status) => status === AuthenticationStatus.Authorized
);
const getIsReadonly = createSelector(getUser, (user) => !!user?.isReadOnly);
const getUserName = createSelector(getUser, (user) =>
    RA.isNotNil(user) ? `${user.firstName} ${user.lastName}` : `Guest`
);

export const AuthSelectors = {
    getAuthenticated,
    getIsReadonly,
    getStatus,
    getUser,
    getUserName
};
